import { render, staticRenderFns } from "./DockerImagesList.vue?vue&type=template&id=5d59c4da"
import script from "./DockerImagesList.vue?vue&type=script&lang=js"
export * from "./DockerImagesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports